<template>
    <div class="d-flex flex-column full-screen text-center align-items-stretch">
        <div class="flex-all d-flex align-items-center justify-content-center">
            <div>
                <div class="dark mb-4">Sign in</div>
                <h1 class="darker">Are you an agent or a supplier?</h1>

                <div class="mt-5">
                    <router-link :to="{ name: 'auth.signup.agent' }" class="btn blue super mr-4 outlined" v-tooltip="agentTooltip">
                        I'm a selling agent
                    </router-link>

                    <router-link :to="{ name: 'auth.signup.supplier' }" class="btn action super outlined" v-tooltip="supplierTooltip">
                        I'm a service supplier
                    </router-link>
                </div>
            </div>
        </div>

        <img class="banner mt-auto" src="/static/images/auth/signup_bottom.jpg" alt="">
    </div>
</template>

<script>
    export default {
        created: function() {
            this.eventHub.$emit('sidebar', '');
            this.eventHub.$emit('topLink', 'login');
        },
        computed: {
            agentTooltip: function() {
                return `<div class="text-center bold color-1 mb-1">Agent</div>
                        <div class="text-center fs-small darker bold mb-1">Sell tours and products on suppliers behalf.</div>
                        <div class="text-center fs-smaller dark">Tour Operators, Travel Agencies, etc.</div>`;
            },
            supplierTooltip: function() {
                return `<div class="text-center bold color-6 mb-1">Supplier</div>
                        <div class="text-center fs-small darker bold mb-1">Own, operate and provide tours and products.</div>
                        <div class="text-center fs-smaller dark">Safari, Surf Lessons, Sea Products, etc.</div>`;
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .banner {
        min-width: 100%;
        height: auto;
    }

    .btn.blue.outlined:hover {
        background: $color-1;
        color: $lightest;
    }

    .btn.action.outlined:hover {
        background: $color-6;
        color: $lightest;
    }
</style>



// WEBPACK FOOTER //
// Signup.vue?3f971b99